import { render, staticRenderFns } from "./OrderImage.vue?vue&type=template&id=bf0792a2&scoped=true&"
import script from "./OrderImage.vue?vue&type=script&lang=js&"
export * from "./OrderImage.vue?vue&type=script&lang=js&"
import style0 from "./OrderImage.vue?vue&type=style&index=0&id=bf0792a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0792a2",
  null
  
)

export default component.exports